import { render, staticRenderFns } from "./MtProductsForm.vue?vue&type=template&id=2376942a&scoped=true&"
import script from "./MtProductsForm.vue?vue&type=script&lang=js&"
export * from "./MtProductsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2376942a",
  null
  
)

export default component.exports